<template>
  <div :data-cy="`dateselection-${id}`">
    <label :for="id" class="glass-label">{{ label }}</label>
    <date-picker
      :id="'datepicker-' + id"
      :ref="'datepicker-' + id"
      :model-value="modelValue"
      locale="fr"
      :enable-time-picker="false"
      teleport-center
      :preview-format="format"
      :format="format"
      :placeholder="placeholder"
      :range="periode"
      auto-apply
      :required="required"
      :disabled="disabled"
      :disable-year-select="noYearPicker"
      :disable-month-year-select="noMonthPicker"
      @update:model-value="(date) => $emit('update:modelValue', date)"
    >
      <!-- Un seul #right-sidebar : raccourcis « période » si range, sinon raccourcis « jour ».
           (!noYearPicker && !noMonthPicker) || !noYearPicker  ⇔  !noYearPicker -->
      <template v-if="periode || !noYearPicker" #right-sidebar>
        <div v-if="!periode" class="h-100 d-flex flex-column justify-content-center">
          <button
            :id="'datepicker-' + id + '-tomorrow'"
            type="button"
            aria-label="Sélectionner la date de demain"
            class="glass-btn-primary d-block mb-2 w-100"
            @click="selectTomorrow"
          >
            Demain
          </button>
          <button
            :id="'datepicker-' + id + '-today'"
            type="button"
            aria-label="Sélectionner la date d'aujourd'hui"
            class="glass-btn-primary d-block mb-2 w-100"
            @click="selectCurrentDay"
          >
            Aujourd'hui
          </button>
          <button
            :id="'datepicker-' + id + '-yesterday'"
            type="button"
            aria-label="Sélectionner la date d'hier"
            class="glass-btn-primary d-block mb-2 w-100"
            @click="selectYesterday"
          >
            Hier
          </button>
          <button
            :id="'datepicker-' + id + '-before-yesterday'"
            type="button"
            aria-label="Sélectionner la date d'avant-hier"
            class="glass-btn-primary d-block mb-2 w-100"
            @click="selectBeforeYesterday"
          >
            Avant-hier
          </button>
        </div>

        <div v-else class="h-100 d-flex flex-column justify-content-center">
          <button
            id="quand-datepicker-1-today"
            type="button"
            class="glass-btn-primary d-block mb-2 w-100"
            @click="selectCurrentDayPeriode"
          >
            Aujourd'hui
          </button>
          <button
            id="quand-datepicker-1-week"
            type="button"
            class="glass-btn-primary d-block mb-2 w-100"
            @click="selectThisWeek"
          >
            Cette semaine
          </button>
          <button
            id="quand-datepicker-1-current-month"
            type="button"
            class="glass-btn-primary d-block mb-2 w-100"
            @click="selectCurrentMonth"
          >
            Ce mois-ci
          </button>
          <button
            id="quand-datepicker-1-previous-month"
            type="button"
            class="glass-btn-primary d-block mb-2 w-100"
            @click="selectPreviousMonth"
          >
            Le mois dernier
          </button>
        </div>
      </template>
    </date-picker>
  </div>
</template>

<script>
// Component
import DatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

export default {
  name: 'DateselectionComponent',

  components: {
    DatePicker
  },

  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: [Date, null, Array],
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    noMonthPicker: {
      type: Boolean,
      default: false
    },
    noYearPicker: {
      type: Boolean,
      default: false
    },
    periode: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:modelValue'],

  data() {
    return {
      placeholder: '../../....'
    }
  },

  mounted() {
    if (this.periode) this.placeholder = '../../.... au ../../....'
    else if (this.noMonthPicker && this.noYearPicker) this.placeholder = '..'
    else if (this.noYearPicker || this.noMonthPicker) this.placeholder = '../..'
  },

  methods: {
    format(date) {
      if (this.periode)
        return `${this.$dayjs(date[0]).format('DD/MM/YYYY')} au ${this.$dayjs(date[1]).format('DD/MM/YYYY')}`
      else if (this.noYearPicker && this.noMonthPicker) return this.$dayjs(date).format('DD')
      else if (this.noYearPicker) return this.$dayjs(date).format('DD/MM')
      return this.$dayjs(date).format('DD/MM/YYYY')
    },
    selectTomorrow() {
      const tomorrow = this.$dayjs().add(1, 'day').toDate()
      this.$emit('update:modelValue', tomorrow)
      this.$refs[`datepicker-${this.id}`].closeMenu()
    },
    selectCurrentDay() {
      const today = this.$dayjs().toDate()
      this.$emit('update:modelValue', today)
      this.$refs[`datepicker-${this.id}`].closeMenu()
    },
    selectYesterday() {
      const yesterday = this.$dayjs().subtract(1, 'day').toDate()
      this.$emit('update:modelValue', yesterday)
      this.$refs[`datepicker-${this.id}`].closeMenu()
    },
    selectBeforeYesterday() {
      const beforeYesterday = this.$dayjs().subtract(2, 'day').toDate()
      this.$emit('update:modelValue', beforeYesterday)
      this.$refs[`datepicker-${this.id}`].closeMenu()
    },

    selectCurrentDayPeriode() {
      let pickedDate = []
      pickedDate[0] = this.$dayjs().startOf('day')
      pickedDate[1] = this.$dayjs().endOf('day')
      pickedDate = pickedDate.map((d) => this.$dayjs(d).format('YYYY-MM-DD'))
      this.$emit('update:modelValue', pickedDate)
      this.$refs[`datepicker-${this.id}`].closeMenu()
    },
    selectCurrentMonth() {
      let pickedDate = []
      pickedDate[0] = this.$dayjs().startOf('month')
      pickedDate[1] = this.$dayjs().endOf('month')
      pickedDate = pickedDate.map((d) => this.$dayjs(d).format('YYYY-MM-DD'))
      this.$emit('update:modelValue', pickedDate)
      this.$refs[`datepicker-${this.id}`].closeMenu()
    },
    selectPreviousMonth() {
      let pickedDate = []
      pickedDate[0] = this.$dayjs().subtract(1, 'month').startOf('month')
      pickedDate[1] = this.$dayjs().subtract(1, 'month').endOf('month')
      pickedDate = pickedDate.map((d) => this.$dayjs(d).format('YYYY-MM-DD'))
      this.$emit('update:modelValue', pickedDate)
      this.$refs[`datepicker-${this.id}`].closeMenu()
    },
    selectThisWeek() {
      let pickedDate = []
      pickedDate[0] = this.$dayjs().startOf('week')
      pickedDate[1] = this.$dayjs().endOf('week')
      pickedDate = pickedDate.map((d) => this.$dayjs(d).format('YYYY-MM-DD'))
      this.$emit('update:modelValue', pickedDate)
      this.$refs[`datepicker-${this.id}`].closeMenu()
    }
  }
}
</script>

<style scoped>
/* Date picker input glassmorphic style */
:deep(.dp__input) {
  background: rgba(255, 255, 255, 0.05) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 12px !important;
  color: #ffffff !important;
  padding: 12px 16px !important;
  padding-left: 40px !important;
  font-size: var(--font-size-sm) !important; /* 16px - Standard web */
  transition: all 0.3s ease !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

:deep(.dp__input:focus) {
  background: rgba(255, 255, 255, 0.08) !important;
  border-color: #6bb4f8 !important;
  box-shadow:
    0 0 0 3px rgba(107, 180, 248, 0.1),
    inset 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  outline: none !important;
}

:deep(.dp__input_icon),
:deep(.dp__input_icons) {
  color: #ffffff !important;
}

:deep(.dp__input::placeholder) {
  color: rgba(255, 255, 255, 0.4) !important;
  font-weight: italic;
}

:deep(.dp__active_date) {
  background-color: #2a4a6b !important;
  color: #ffffff !important;
  border: none;
}

:deep(.dp__today) {
  border: 1px solid #2a4a6b !important;
}
</style>
